<template>
  <div class="clipboard__main">
    <div class="clipboard__header">
      <div class="clipboard__icon">&#57350;</div>
      <div class="clipboard__num">{{ num }}</div>
    </div>
    <swiper class="clipboard__slider" :ref="`clipboard-${nth}`" :options="swiperOptions">
      <template v-for="img in imgs">
        <swiper-slide :key="img.id">
          <img class="clipboard__img" :src="img.src" />
          <div class="clipboard__caption">
            <div class="clipboard__caption-content" v-html="changeLang(img.caption)"></div>
            <div class="clipboard__doc" v-if="img.caption.doc">
              <span v-html="'&#57347;'"></span>
              <div v-html="img.caption.doc"></div>
            </div>
          </div>
        </swiper-slide>
      </template>
    </swiper>
    <div class="clipboard__nav">
      <div class="clipboard__prev" @click="clipboardSwiper.slidePrev()">PREV</div>
      <div
        class="clipboard__pagination"
      >{{ clipboardSwiper.activeIndex + 1 + " / " + slidesLength }}</div>
      <div class="clipboard__next" @click="clipboardSwiper.slideNext()">NEXT</div>
    </div>
  </div>
</template>

<style scoped>
.clipboard__main {
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 20px;
  width: 100%;
  font-size: 12px;
  color: #000000;
  background-color: #ccad8f;
  overflow: hidden;
}

.clipboard__header {
  display: flex;
  padding: 20px;
}

.clipboard__icon {
  margin-right: 20px;
}

.clipboard__slider {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
}

.clipboard__img {
  width: 100%;
}

.clipboard__caption {
  border-top: 1px solid #000000;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
}

.clipboard__caption > div {
  padding: 20px;
}

.clipboard__doc {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #000000;
  font-size: 10px;
}

.clipboard__doc > * {
  width: 50%;
}

.clipboard__nav {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #000000;
  padding: 20px;
  width: 100%;
}

.clipboard__nav > div {
  font-size: 12px;
  user-select: none;
}

.clipboard__pagination {
  text-align: center;
}

.clipboard__prev,
.clipboard__next {
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  .clipboard__doc {
    font-size: 10px;
  }

  .clipboard__doc span {
    padding-bottom: 20px;
    width: 100%;
  }

  .clipboard__doc div {
    width: 100%;
  }
}
</style>

<script>
export default {
  title: "Clipboard",
  props: {
    nth: String,
    num: String,
    imgs: Array,
    caption: String
  },
  data() {
    return {
      swiperOptions: {
        preloadImages: true,
        autoHeight: true,
        updateOnWindowResize: true,
        grabCursor: true
      },
      clipboardSwiper: {},
      slidesLength: Number
    };
  },
  methods: {
    changeLang(data) {
      return this.$route.query.lang === "en" ? data.en : data.hu;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.clipboardSwiper = this.$refs[`clipboard-${this.nth}`].$swiper;
      this.slidesLength = this.clipboardSwiper.slides.length;
    });
  }
};
</script>
